import type { ReactNode } from 'react';
import { Box, useTheme } from '@mui/material';
import { getContrastRatio } from '@mui/system/colorManipulator';

export function ColorSwatch({
  hexCode,
  children,
}: {
  hexCode: string;
  children?: ReactNode;
}) {
  const theme = useTheme();

  let lowContrast = true;
  try {
    lowContrast =
      getContrastRatio(hexCode, theme.palette.background.paper) < 1.5;
  } catch {
    /* invalid hex */
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Box
        aria-hidden
        sx={{
          m: 0.25,
          width: 20,
          height: 20,
          flexShrink: 0,
          borderRadius: 0.5,
          boxSizing: 'border-box',
          bgcolor: hexCode,
          border: '1px solid',
          borderColor: lowContrast ? 'divider' : hexCode,
        }}
      />
      {children != null ? <span>{children}</span> : null}
    </Box>
  );
}
